import AssignedSiteList from "../components/AssignedSiteList";

function AssignedSiteListPage() {
  return <AssignedSiteList />;
}

export default AssignedSiteListPage;
